import CustomLoader from "@/components/Loader/CustomLoader";
import { useUserContext } from "@/context/UserContext";
import { Suspense } from "react";
import { Outlet, RouterProvider, createBrowserRouter } from "react-router-dom";
import CustomDialog from "./components/Dialog/CustomDialog";
import OverflowTooltip from "./components/Tooltip/OverflowTooltip";
import { DialogProvider } from "./context/DialogContext";
import usePageHeadSettings from "./hooks/usePageHeadSettings";
import ErrorBoundary from "./modules/ErrorBoundary";
import { MainRoutes } from "./routes/main.routes";
import { PublicRoutes } from "./routes/public.routes";

export default function Routes() {
  const { user, doesPreviousUserExists } = useUserContext();
  const router = createBrowserRouter([
    {
      path: "/",
      element: <App />,
      children: [...MainRoutes({ user, doesPreviousUserExists }), ...PublicRoutes],
      errorElement: <ErrorBoundary />,
    },
  ]);

  return <RouterProvider router={router} fallbackElement={<CustomLoader />} />;
}
function App() {
  usePageHeadSettings();

  return (
    <div
      className="App"
      style={{ width: "100%", height: "100%", minHeight: "100vh" }}
    >
      <Suspense fallback={<CustomLoader />}>
        <DialogProvider>
          <CustomDialog />
          {/* One listener for the whole app: reveals any text the CSS has
              clipped with an ellipsis. Mounted here so nothing below has to
              observe its own elements. */}
          <OverflowTooltip />
          <Outlet />
        </DialogProvider>
      </Suspense>
    </div>
  );
}
